<template>
  <div class="order-block order-group-recognizee" id="theInsuredList">
    <div class="header">
      <div class="header-title">被保人信息（{{insuranceData.insurants.length}}/{{insuranceData.max_people}}人）</div>
      <div class="btn-box">
        <ocr-upload-btn :insurance-data="insuranceData" @ocr-submit="ocrSubmit"></ocr-upload-btn>
        <a href="https://o.666visa.cn/static/ssqpeer/%E4%BF%9D%E9%99%A9%E5%9B%A2%E5%8D%95%E6%A8%A1%E6%9D%BF.xls" download target="_blank">下载Excel模板</a>
        <batch-upload-btn :insurance-data="insuranceData" @batch-upload="batchUpload"></batch-upload-btn>
      </div>
    </div>

    <!-- 历史申请人 -->
    <div class="historical-applicant-list-wrapper">
      <historical-applicant-list :insurants="insuranceData.insurants" :insurance-data="insuranceData" @del-applicant="delApplicant" @add-applicant="addApplicant"></historical-applicant-list>
    </div>

    <el-form class="recognizee-box-wrap" ref="groupDataForm" :inline="true" :show-message="false" :rules="rules" :model="insuranceData">
      <table class="recognizee-table" id="insurants_table">
        <thead>
          <th width="44"></th>
          <th width="86">姓名</th>
          <th width="113">姓名拼音</th>
          <th width="90">证件类型</th>
          <th>证件号码</th>
          <th width="60">性别</th>
          <th width="115">出生日期</th>
          <th v-if="insuranceData.job_set">职业</th>
          <th v-if="currentInsuranceTypeIsPersonal">与投保人关系</th>
          <th width="50"></th>
        </thead>
        <tbody>
          <tr v-for="(ins, index) in insuranceData.insurants" :key="index">
            <td class="td-index">{{index + 1}}</td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.cname'" :rules="[ ...rules['insurants.cname'], checkRepeat]">
                <el-input v-model.trim="ins.cname" placeholder="请输入" :maxlength="100" @blur="calculatePinyin(ins, false, 100)" ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.ename'" :rules="rules['insurants.ename']">
                <el-input v-model.trim="ins.ename" placeholder="请输入" :maxlength="100" ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.card_type'" :rules="rules['insurants.card_type']" v-if="supportIdCard || supportPassport">
                <el-select v-model="ins.card_type" placeholder="请选择" >
                  <el-option label="身份证" :value="1" v-if="supportInsurantTypeIdCard"></el-option>
                  <el-option label="护照" :value="2" v-if="supportInsurantTypePassport"></el-option>
                </el-select>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.card_code'"
                :rules="ins.card_type === 2 ? rules['insurants.passport'] : rules['insurants.idCard']">
                <el-input v-model.trim="ins.card_code" placeholder="请输入" :maxlength="18" @change="extractInfoFromIdcard(ins)" ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.sex'" :rules="rules['insurants.sex']">
                <el-select v-model="ins.sex" placeholder="" >
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" :prop="'insurants.'+ index +'.birthday'" :rules="rules['insurants.birthday']">
                <el-date-picker v-model.trim="ins.birthday" format="yyyy-MM-dd" default-value="1988-06-01" placeholder="请选择"
                  :editable="false" type="date" :picker-options="pickerOptionsForBirthday" >
                </el-date-picker>
              </el-form-item>
            </td>
            <td v-if="insuranceData.job_set">
              <el-form-item label="" :prop="'insurants.'+ index +'.job'" :rules="rules['insurants.job']">
                <el-cascader
                  :options="transformJob"
                  v-model="ins.job"
                >
                </el-cascader>
              </el-form-item>
            </td>
            <td v-if="currentInsuranceTypeIsPersonal">
              <el-form-item label="" :prop="'insurants.'+ index +'.relation_id'" :rules="rules['insurants.relation_id']">
                <!-- 开启投保人本人投保，禁用切换关系 -->
                <el-select v-model="ins.relation_id" placeholder="请选择" :disabled="!!insuranceData.is_self_insure">
                  <el-option
                    v-for="(value, key) in insurantRelationMap"
                    :key="key"
                    :label="value"
                    :value="+key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </td>
            <td class="btn-td">
              <div v-if="insuranceData.insurants.length > 1" class="delete-btn" @click="deleteInsurant(index, true)"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="recognizee-add" @click="addInsurant" v-if="insuranceData.insurants.length < insuranceData.max_people">
        <img :src="$importImage('insurance-new/recognizee-add.png')" alt="">
        添加被保人
      </div>
    </el-form>

  </div>
</template>


<script>
import utils from '@/libs/utils';
import 'pinyin4js';
import { insurantRelationMap } from '@/pages/insurance/consts/maps';
import historicalApplicantList from './components/historical-applicant-list.vue';
import insuranceInfoService, { rules } from '@/pages/insurance/services/insurance-info-service';
import _ from 'lodash';
import ocrUploadBtn from './components/ocr-upload-btn.vue';
import batchUploadBtn from './components/batch-upload-btn.vue';


export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    historicalApplicantList,
    ocrUploadBtn,
    batchUploadBtn,
  },
  data() {
    return {
      rules,
      insurantRelationMap,
      pickerOptionsForBirthday: {
        disabledDate() {
          return false;
        },
      },
      insuranceData: undefined,
      checkRepeat: { validator: this.checkRepeatFn, trigger: 'blur' },
    };
  },
  computed: {
    transformJob() {
      if (!this.insuranceData.job_set || !this.insuranceData.job_set.jobs) return [];
      const originalJobList = this.insuranceData.job_set.jobs.map(item => ({ ...item, value: item.id, label: item.name }));
      const jobList = [];
      // 添加第一层
      originalJobList.forEach((item) => {
        if (!item.parentId) {
          jobList.push(item);
        }
      });

      // 添加第二层
      originalJobList.forEach((item) => {
        const firstJobIndex = jobList.findIndex(firstJob => firstJob.id === item.parentId);
        if (firstJobIndex !== -1) {
          jobList[firstJobIndex].children = jobList[firstJobIndex].children || [];
          jobList[firstJobIndex].children.push(item);
        }
      });
      // 添加第三层
      originalJobList.forEach((item) => {
        let firstJobIndex = -1;
        let secondJobIndex = -1;
        for (let i = 0; i < jobList.length; i++) {
          const firstJob = jobList[i];
          const tempSecondJobIndex = firstJob.children.findIndex(secondJob => secondJob.id === item.parentId);
          if (tempSecondJobIndex !== -1) {
            secondJobIndex = tempSecondJobIndex;
            firstJobIndex = i;
            break;
          }
        }
        if (firstJobIndex !== -1 && secondJobIndex !== -1 && item.isInsure === '是') {
          jobList[firstJobIndex].children[secondJobIndex].children = jobList[firstJobIndex].children[secondJobIndex].children || [];
          jobList[firstJobIndex].children[secondJobIndex].children.push(item);
        }
      });

      jobList.forEach((firstItem) => {
        firstItem.children = firstItem.children.filter(secondItem => secondItem.children && secondItem.children.length);
      });

      return jobList;
    },
    currentInsuranceTypeIsPersonal() {
      // 投保类型 0个人 1公司
      return this.insuranceData && this.insuranceData.insurance_type_id === 0;
    },
    // 投保人支持的证件类型
    supportPassport() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(2);
    },
    supportIdCard() {
      // 1身份证 2护照
      return this.insuranceData.applicant_type_set && this.insuranceData.applicant_type_set.includes(1);
    },
    // 被保人支持的证件类型
    supportInsurantTypePassport() {
      // 0其他 1身份证 2护照
      return this.insuranceData.insurant_type_set && this.insuranceData.insurant_type_set.includes(2);
    },
    supportInsurantTypeIdCard() {
      // 0其他 1身份证 2护照
      return this.insuranceData.insurant_type_set && this.insuranceData.insurant_type_set.includes(1);
    },
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.insuranceData)) {
          this.insuranceData = utils.deepCopy(val);
        }
      },
      deep: true,
      immediate: true,
    },
    insuranceData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    // 证件号码校验函数
    checkRepeatFn(rule, value, callback) {
      const nameList = rule.fullField.split('.');
      if (!nameList[1]) {
        callback();
        return;
      }
      const number = +nameList[1];
      const otherList = this.insuranceData.insurants.filter((it, index) => index !== number);
      const currentVal = this.insuranceData.insurants[number];
      if (!currentVal) {
        callback();
        return; 
      }


      // 判断是否有重复数据
      const key = `${currentVal.cname}_${currentVal.card_code}`;    
      const repeatObj = otherList.filter(it => `${it.cname}_${it.card_code}` === key);
      if (repeatObj && repeatObj.length) {
        callback(new Error('重复了'));
      } else {
        callback();
      }
    },

    // 根据输入的汉字计算拼音
    calculatePinyin(item, needEmptyEname, length) {
      if (item.cname && (needEmptyEname || !item.ename)) {
        item.ename = PinyinHelper.convertToPinyinString(item.cname, '#', PinyinFormat.WITHOUT_TONE)
          .split('#')
          .map(pin => pin.substring(0, 1).toUpperCase() + pin.substring(1))
          .join('')
          .substring(0, length);
        this.$forceUpdate();
      }
    },
    // 从身份证抽取信息，并自动填入
    extractInfoFromIdcard(item) {
      insuranceInfoService.extractInfoFromIdcard(item);
    },
    // 删除被保人
    deleteInsurant(index, noConfirm) {
      const _this = this;
      if (this.insuranceData.insurants.length >= 2) {
        if (noConfirm) {
          _this.insuranceData.insurants.splice(index, 1);
          utils.msg.success('删除成功！');
        } else {
          utils.msgbox.confirm(`确定要删除被保人${index + 1}吗？`, '删除被保人', {
            confirmButtonText: '确定',
            cancelButtonText: '再想想',
            type: 'warning',
          }).then(() => {
            _this.insuranceData.insurants.splice(index, 1);
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      }
    },
    // 增加被保人
    addInsurant() {
      if (this.insuranceData.insurants.length < 200) {
        this.insuranceData.insurants.push({
          cname: '',
          ename: '',
          card_type: '',
          card_code: '',
          sex: '',
          birthday: '',
          relation_id: this.insuranceData.is_self_insure ? 1 : undefined,
        });
      }
    },
    async ocrSubmit(newInsurantList) {
      this._deleteEmptyData(newInsurantList.length);

      this.insuranceData.insurants = newInsurantList.concat(this.insuranceData.insurants);
      this.$nextTick(() => {
        this.validate();
      });
    },
    async batchUpload(newInsurantList) {
      this._deleteEmptyData(newInsurantList.length);

      this.insuranceData.insurants = newInsurantList.concat(this.insuranceData.insurants);
      this.$nextTick(() => {
        this.validate().catch(() => {
          // 取出来所有报错的字段
          const errorFieldList = this.$refs.groupDataForm.fields.filter(item => item.validateState === 'error');
          // 取出来所有报错的字段对应的行
          let errorRowList = errorFieldList.map(item => +item.prop.split('.')[1] + 1);
          // 去重
          errorRowList = _.uniq(errorRowList);
          if (errorRowList.length) {
            utils.msgbox.alert(`序号为${errorRowList.join('、')}的行信息有误, 请检查`, '系统提示');
          }
        });
      });

    },  
    // 删除历史申请人
    delApplicant(archives_id) {
      if (!archives_id) return;
      const index = this.insuranceData.insurants.findIndex(it => it.archives_id === archives_id);
      if (index !== -1) {
        this.insuranceData.insurants.splice(index, 1);
        // 如果删除到没有数据则需要添加一个空数据
        if (!this.insuranceData.insurants.length) {
          this.insuranceData.insurants = [
            {
              cname: '',
              ename: '',
              card_type: '',
              card_code: '',
              sex: '',
              birthday: '',
              relation_id: this.insuranceData.is_self_insure ? 1 : undefined,
            },
          ];
        }
      }
    },
    // 选中历史申请人
    addApplicant(newInsurant) {
      this._deleteEmptyData();
      this.insuranceData.insurants.unshift(newInsurant);
    },
    // 判断是否存在有空的数据，如果则，则需要删除
    _deleteEmptyData(len = 1) {
      if (!len) return;
      const empatyDataIndexList = [];
      this.insuranceData.insurants.forEach((it, index) => {
        const isEmpty = Object.keys(it).every(key => it[key] !== 0 && !it[key]);
        if (isEmpty) {
          empatyDataIndexList.push(index);
        }
      });

      const length = Math.min(len, empatyDataIndexList.length);
      if (!length) return;
      const delIndexList = empatyDataIndexList.slice(0, length);
      this.insuranceData.insurants = this.insuranceData.insurants.filter((_, index) => !delIndexList.includes(index));
    },

    // 判断是否存在重复的内容
    validateRepeat() {

      // 跳转到指定元素，并抖动
      const scrollToErrorEl = function (selector) {
        const el = document.querySelector(selector);
        if (!el) return;
        window.scrollTo({
          top: el.offsetTop,
          behavior: 'smooth',
        });
      };

      const keyList = [];
      const repeatIndexList = [];
      this.insuranceData.insurants.forEach((it, index) => {
        if (it.cname || it.card_code) {
          const key = `${it.cname}_${it.card_code}`;
          if (keyList.includes(key)) {
            repeatIndexList.push(index);
          } else {
            keyList.push(key);
          }
        }
      });

      if (repeatIndexList && repeatIndexList.length) {
        scrollToErrorEl('#insurants_table');
        utils.msg.error('被保人重复，请检查后再提交');
        return false;
      }
      return true;
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.currentInsuranceTypeIsPersonal && this.insuranceData.for_who === 1) {
          // 个人，为自己投保，不需要校验，直接成功
          resolve();
        } else {
          this.$refs.groupDataForm.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject('#theInsuredList');// 抛id出去，做滚动
            }
          });
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.order-group-recognizee{
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    height: 44px;
    background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
    .header-title{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
    }
    .btn-box{
      display: flex;
      align-items: center;
      >div {
        margin-left: 24px;
      }
      a{
        color: #599FFF;
        font-size: 14px;
        margin-left: 24px;
      }
    }
  }
  .historical-applicant-list-wrapper {
    margin: 0 24px;
    padding: 20px 0;
    border-bottom: 1px dashed #E9EEF2;
  }


  .recognizee-box-wrap{
    padding: 20px 24px;
    .recognizee-table{
      background: #FAFBFC;
      border-spacing: 0;
      thead{
        th{
          border-bottom: 1px solid #E9EEF2;
          font-size: 14px;
          color: #2F333D;
          font-weight: 600;
          height: 44px;
        }
      }
      tbody{
        tr{
          &:first-child{
            td{
              padding-top: 20px;
            }
          }
          &:last-child{
            td{
              padding-bottom: 20px;
            }
          }
        }
        td{
          padding: 8px 5px;
          text-align: center;
          &.td-index{
            font-size: 12px;
            color: #2F333D;
          }
          .delete-btn{
            display: inline-block;
            background: url(../../../../../../../../assets/imgs/insurance-new/icon-delete.png) no-repeat center / 100% 100%;
            width: 20px;
            height: 20px;
            cursor: pointer;
            margin-right: 0;
          }
        }
      }
      /deep/ .el-form-item{
        width: 100%;
        padding: 0;
        margin-bottom: 0;
        .el-form-item__content{
          .el-date-editor{
            .el-input__icon{
              display: none;
            }
            .el-input__inner{
              padding: 3px 10px;
            }
          }
        }
      }
    }
  }
  .recognizee-add {
    margin: 0 auto;
    width:150px;
    height:36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background:rgba(89,159,255,0.08);
    font-size: 16px;
    color: #599FFF;
    cursor: pointer;
    border-radius: 18px;
    line-height: 1;
    margin-top: 20px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }
  .next-step {
    height: 82px;
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    background: #fff;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .next-protocol{
      font-size: 14px;
      color: #2F333D;
      line-height: 1;
      .next-check{
        /deep/ .el-checkbox__inner{
          width: 16px;
          height: 16px;
          &::after{
            left: 4px;
          }
        }
      }
      .next-url{
        color: #599FFF;
        cursor: pointer;
      }
    }
    .next-button{
      width:200px;
      height:50px;
      background: #599FFF;
      border-radius:2px;
      color: #fff;
      font-size: 16px;
    }
  }

}



</style>


// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/insuranceInfo/components/left-insurance-form/components/theInsured-list/theInsured-list.vue